export const API_URL: string = process.env.REACT_APP_API_URL || 'https://api.getnovala.com';

// Count of upcoming filings shown on the Filings tab (T4 summary, T4 employer, T4 employee).
// Keep in sync with FilingsTab COMING UP section when adding new filing types.
export const UPCOMING_FILINGS_COUNT = 3;